<div class="user-holder">
    <span class="user">Logged in as : {{usr.user}}</span>
    <span class="user" style="float:right">{{usr.locale}}</span>
</div>
